module.exports = __webpack_public_path__ + "img/vierassatama_original.8d9bfee0.jpg";